import React from 'react';

interface Props {
  message?: string;
  onSkip?: () => void;
}

export default function ConnectingOverlay({ message, onSkip }: Props) {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-xl p-8 flex flex-col items-center shadow-2xl">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-brand mb-4"></div>
        <p className="text-foreground text-lg font-medium">
          {message || 'Connecting to site…'}
        </p>
        <p className="text-muted-foreground text-sm mt-2">
          Establishing tunnel connection
        </p>
        {onSkip && (
          <button
            onClick={onSkip}
            className="mt-4 text-[13px] text-muted-foreground hover:text-foreground transition-colors underline"
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
}
